import axios from 'axios'

const client = axios.create({
  // baseURL: 'http://localhost:8030/',
  json: true
})

// Client-Side requests
export default {
  async executeGet (resource, params) {
    const res = await client({
      method: 'get',
      url: resource,
      params
    })
    return res.data
  },
  async executePost (resource, data) {
    const res = await client({
      method: 'post',
      url: resource,
      data
    })
    return res.data
  },
  async execute (method, resource, data) {
    const res = await client({
      method,
      url: resource,
      data
    })
    return res.data
  },

  getPosts (resource, params) {
    return this.executeGet(`/${resource}`, params)
  },
  getPost (resource, id) {
    return this.executeGet(`/${resource}/${id}`)
  },
  getCategoryLists (categories) {
    return this.executePost('/categories', { categories })
  },
  getMedicalFilterOptions () {
    return this.executeGet('/medical-filter-options')
  },
  createPost (resource, data) {
    return this.executePost(`/${resource}`, data)
  },
  uploadImage (dayID, data) {
    return this.executePost(`/image/${dayID}`, data)
  },
  createPosts (resource, data, isExperiment) {
    return (isExperiment) ? this.executePost(`/bulk-exudats/${resource}`, data) : this.executePost(`/bulk-${resource}`, data)
  },
  updatePost (resource, id, data) {
    return this.execute('put', `/${resource}/${id}`, data)
  },
  moveToTrashOrRestore (resource, ids, isExperiment, restore) {
    const putResource = (isExperiment) ? `/move-exudats-to-trash-or-restore/${resource}` : `/move-to-trash-or-restore/${resource}`
    return this.execute('put', putResource, {ids, restore})
  },
  deletePost (resource, id) {
    return this.execute('delete', `/${resource}/${id}`)
  },
  deletePosts (resource, ids, isExperiment) {
    return (isExperiment) ? this.execute('delete', `/bulk-exudats/${resource}`, {ids}) : this.execute('delete', `/bulk-${resource}`, {ids})
  },
  getPatientsToAssoc (param, data) {
    return this.executePost(`/patients-to-assoc/${param}`, data)
  },
  getUser () {
    return this.executeGet('user')
  },
  logout () {
    return this.executePost('logout')
  },
  setConfigCookie (config) {
    return this.executePost('set-columns', config)
  },
  getQueryCookie (postResource) {
    return this.executeGet(`query/${postResource}`)
  },
  setQueryCookie (query) {
    return this.executePost('set-query', query)
  },
  deleteCookies () {
    return this.executePost('delete-cookies')
  }
}



// WEBPACK FOOTER //
// ./src/api.js